import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/goods/getList',
    method: 'get',
    params,
  })
}

export function getMitmbaspDetail(data) {
  return request({
    url: '/api/v1/api/mitmbasp',
    method: 'get',
    params: data,
  })
}
